import type { CardMetadata } from '../../-types/card';
import { FeeViewer } from './fee-viewer';
import { SpendingControls } from './spending-controls';

interface ControlsTabProps {
  metadata: CardMetadata;
}

export function ControlsTab({ metadata }: ControlsTabProps) {
  return (
    <div className="space-y-6">
      <SpendingControls metadata={metadata} />
      <FeeViewer metadata={metadata} />
    </div>
  );
}
